var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"600"},model:{value:(_vm.loginState),callback:function ($$v) {_vm.loginState=$$v},expression:"loginState"}},[_c('login-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }